<template>
  <span class="text-no-wrap">
    {{ phone || '' }}
    <span v-if="ext">
      ext. {{ ext }}
    </span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  ext?: string
  phone?: string
}>()
</script>
